<template>
  <el-form ref="form" :model="form" label-width="80px">
    <el-form-item
      label="单位名称"
      prop="companyName"
      :rules="[
      { required: true, message: '不能为空'}
    ]"
    >
      <el-input v-model="form.companyName" prop="companyName" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item
      label="内部锁号"
      prop="innerEncryptNo"
      :rules="[
      { required: true, message: '不能为空'}
    ]"
    >
      <el-input
        v-model="form.innerEncryptNo"
        prop="innerEncryptNo"
        autocomplete="off"
        placeholder="请输入正确的加密锁号,例如：2-1234567"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="申请说明"
      prop="Explain"
      :rules="[
      { required: true, message: '不能为空'}
    ]"
    >
      <el-input type="textarea" v-model="form.Explain" prop="Explain" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="选择产品">
      <el-checkbox-group v-model="form.type">
        <el-checkbox-button label="方案设计师V5.1" name="type"></el-checkbox-button>
        <el-checkbox-button label="方案设计师V4.2" name="type"></el-checkbox-button>
        <el-checkbox-button label="桥梁博士V4.1" name="type"></el-checkbox-button>
        <el-checkbox-button label="桥梁博士V3.6" name="type"></el-checkbox-button>
        <el-checkbox-button label="桥梁设计师V1.0" name="type"></el-checkbox-button>
        <el-checkbox-button label="桥梁博士基础版" name="type"></el-checkbox-button>
        <el-checkbox-button label="桥梁Bim设计系统" name="type"></el-checkbox-button>
        <el-checkbox-button label="河北院定制通用图" name="type"></el-checkbox-button>
        <el-checkbox-button label="浙江省院矮T梁通用图" name="type"></el-checkbox-button>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item
      label="开通时长"
      prop="time"
      :rules="[
      { required: true, message: '不能为空'}
    ]"
    >
      <el-input v-model="form.time" placeholder="请输入天数,1-90" prop="time" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">立即申请</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  data() {
    return {
      form: {
        companyName: "",
        innerEncryptNo: "",
        Explain: "",
        time: "",
        type: [],
      },
    };
  },
  methods: {
    onSubmit() {
      let formData = new FormData();
      formData.append("innerEncryptNo", this.form.companyName);
      formData.append("innerEncryptNo", this.form.innerEncryptNo);
      formData.append("innerEncryptNo", this.form.Explain);
      formData.append("innerEncryptNo", this.form.time);
      formData.append("innerEncryptNo", this.form.type[0].name);
      this.$http
        .post(this.$getaxiosurl("/enc/contract/queryContract"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              message: "提交成功",
              type: "success",
            });
          } else {
            this.$message({
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
  },
};
</script>